import { getItemListByPosition, getItemPrototypeListByPosition, getItem, getItemDefaultProps, } from '@/common/util/util';
import { allCellMap } from '@/common/manager/cell';
import DocSetter from '@/common/setter/doc-setter';
import { DisplayPosition } from '@/type/display-position';
export function createFormatSetters(config) {
    const result = [
        {
            name: 'format',
            title: '数据类型',
            display: 'inline',
            extraProps: {
                setValue(target, value) {
                    const defaultProps = getItemDefaultProps(allCellMap, DisplayPosition.tableCell, value);
                    const oldOptions = target?.parent?.getPropValue?.('options') || {};
                    if (defaultProps) {
                        target?.parent?.setPropValue?.('options', {
                            ...oldOptions,
                            ...defaultProps,
                        });
                    }
                    else {
                        target?.parent?.setPropValue?.('options', {});
                    }
                },
            },
            setter: {
                componentName: 'SelectSetter',
                // props: {
                //   options: cellList,
                // },
                props: () => {
                    return {
                        options: getItemListByPosition({
                            position: DisplayPosition.tableCell,
                            componentMap: allCellMap,
                        }),
                    };
                },
            },
        },
        {
            display: 'none',
            setter: (React.createElement(DocSetter, { content: React.createElement("a", { target: '_blank', href: 'https://yuque.antfin.com/docs/share/63fd9c72-a3a8-467f-a5dd-03d45a04c36e#uz0eb', rel: 'noreferrer' }, "\u6570\u636E\u7C7B\u578B\u6587\u6863\u94FE\u63A5") })),
        },
    ];
    const { position } = config || {};
    result.push({
        name: 'options',
        display: 'block',
        title: '请完善数据类型的配置项',
        condition(prop) {
            const format = prop?.parent?.getPropValue?.('format');
            if (format) {
                const item = getItem(allCellMap, position, format) || {};
                const { getPrototypeList, configure = [] } = item;
                if ((getPrototypeList && getPrototypeList()?.length > 0) ||
                    configure?.length > 0) {
                    return true;
                }
            }
            return false;
        },
        setter: {
            componentName: 'ObjectSetter',
            props: () => {
                return {
                    config: {
                        items: [
                            ...getItemPrototypeListByPosition({
                                position,
                                primaryKey: 'format',
                                componentMap: allCellMap,
                            }),
                        ],
                    },
                };
            },
        },
    });
    return result;
}
